import { apiFetchJson } from '@/lib/api-fetch'

export interface AppSubscriptionRow {
  status: string | null
  current_period_end: string | null
  stripe_customer_id: string | null
  stripe_subscription_id: string | null
  product: string | null
  source: string | null
  voucher_code: string | null
}

/** Variant B: latest subscription row from FairHelm API (same shape used by `useSubscriptionInfo`). */
export async function fetchAppSubscription(): Promise<AppSubscriptionRow> {
  return apiFetchJson<AppSubscriptionRow>('/api/app/v1/subscriptions/me')
}
